import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { Dropdown } from "primeng/dropdown";
import { DialogService } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { UserService } from "../../../../shared";
import { MenuService } from "../../../master/services";
import { DataService_AdvancedPreferences } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-prefs-caass-notify-school-table",
	templateUrl: "./prefs-caass-notify-school-table.component.html",
	styleUrls: ["./prefs-caass-notify-school-table.component.css"],
})
export class PrefsCaassNotifySchoolTableComponent implements OnInit {
	constructor(
		private userService: UserService,
		private PrefsCaassNotifySchoolTableService: DataService_AdvancedPreferences,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService,
		private menuService: MenuService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadSchool();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	//Used To Filter Active By Default
	@ViewChild("mydt") mydt: Table;
	@ViewChild("filterActiveDesc", { static: false })
	public filterActiveDesc: Dropdown;

	processing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSchools: any = [];
	lstSchool: any = [];

	//Filter lists
	lstNotifyEnabled: any = [];
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		// { field: 'NotifyEnabled', header: 'Notify Enabled' },
		{ field: "SchoolID", header: "School ID" },
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
		{ field: "c_dateDesc", header: "Last Updated" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSchool() {
		this.loading = true;

		var result = this.PrefsCaassNotifySchoolTableService.NotifySchoolInfoSelectList();
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				for (var i = 0; i < this.lstSchool.length; i++) {
					var next = this.lstSchool[i];

					next.c_dateDesc = next.c_date == "0001-01-01T00:00:00" ? "" : moment(new Date(next.c_date)).format("MM/DD/YYYY h:mm a");
				}

				//Load Data Filter Lists
				this.lstNotifyEnabled = Array.from(new Set(this.lstSchool.map((item: any) => item.NotifyEnabled))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstSchool.map((item: any) => item.ActiveDesc))).sort();

				var ActiveSet = new Set(this.lstSchool.map((item: any) => item.ActiveDesc));

				if (ActiveSet.has("Active")) {
					this.mydt.filters.ActiveDesc["value"] = "Active";
				}

				this.loading = false;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.errorMessage = "";

		this.loadSchool();
	}

	onEnableNotify() {
		//Error handling
		if (this.SelectedSchools.length == 0) {
			this.errorMessage = "Select schools to enable";
			return;
		}

		this.processing = true;

		//Create list of IDs
		var lstSchoolIDs: number[] = [];

		for (var i = 0; i < this.SelectedSchools.length; i++) {
			var next = this.SelectedSchools[i];

			lstSchoolIDs = [...lstSchoolIDs, next.SchoolID];
		}

		//Call SP
		var result = this.PrefsCaassNotifySchoolTableService.EnableCAASSNotify(lstSchoolIDs);
		result.subscribe(
			(response) => {
				this.processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "notify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "CAASS Notify was enabled successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.SelectedSchools = [];
							this.loadSchool();
							this.menuService.MenuRefreshAll("refresh");
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "notify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not enable CAASS Notify",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	onDisableNotify() {
		//Error handling
		if (this.SelectedSchools.length == 0) {
			this.errorMessage = "Select schools to enable";
			return;
		}

		this.processing = true;

		//Create list of IDs
		var lstSchoolIDs: number[] = [];

		for (var i = 0; i < this.SelectedSchools.length; i++) {
			var next = this.SelectedSchools[i];

			lstSchoolIDs = [...lstSchoolIDs, next.SchoolID];
		}

		//Call SP
		var result = this.PrefsCaassNotifySchoolTableService.DisableCAASSNotify(lstSchoolIDs);
		result.subscribe(
			(response) => {
				this.processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "notify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "CAASS Notify was disabled successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.SelectedSchools = [];
							this.loadSchool();
							this.menuService.MenuRefreshAll("refresh");
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "notify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not disable CAASS Notify",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	onClear() {
		this.SelectedSchools = [];
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";
	}
	onRowUnselect(val) {
		this.errorMessage = "";
	}
	////////////////////////////////////////////
}
